/**
 * Update the cart preview
 *
 * @param data
 */
window.updateCartPreviewCount = (data) => {
    if (typeof data != 'undefined') {

        // update total amount
        if(data.count) {
            $('.cart-preview-count').html(data.count);
        }

        // update single item if item was modified / added
        if (data.itemId) {
            $(`.article-amount-in-cart[data-article="${data.itemId}"] [data-article-item-count]`).text('' + data.itemQuantity);
            if (data.itemQuantity > 0) {
                $(`.article-amount-in-cart[data-article="${data.itemId}"]`).removeClass('hidden');
            } else {
                $(`.article-amount-in-cart[data-article="${data.itemId}"]`).addClass('hidden');
            }
        }

        // check if article specific amount is displayed and if item got removed completely
        if (data.currentItems && Array.isArray(data.currentItems)) {
            const elements = document.querySelectorAll('.article-amount-in-cart');
            const articleNumbersInCart = data.currentItems.map((item) => item.itemId);
            Array.from(elements).forEach((element) => {
                const articleNumber = element.dataset.article;
                if (articleNumbersInCart.indexOf(articleNumber) === -1) {
                    element.classList.add('hidden');
                }
            });
        }
    }
}
